import auth from "@/auth/localization/en"
import cardCollection from "@/collection/localization/en"
import course from "@/course/localization/en"
import folaBoard from "@/folaBoard/localization/en"
import personalDashboard from "@/personalDashboard/localization/en"
import user from "@/user/localization/en"

const strings = {
	auth,
	cardCollection,
	course,
	folaBoard,
	personalDashboard,
	user,

	core: {
		about: "About us",
		accessibility: "Accessibility",
		bloomLevel: "Bloom Level",
		board: "Session",
		close: "Close",
		conceptResearch: "Concept & Research",
		confirmAbortCreation: (thing: string | undefined) =>
			`Some fields are not valid. No ${thing ?? ""} will be created. Do you really want to close the editor?`,
		confirmDelete: "Are you sure you want to delete this item?",
		contactUs: "Contact Us",
		copied: "Copied!",
		copyLink: "Copy Link to Clipboard",
		course: "Course",
		credits: [],
		createBoard: "Create Session",
		createCourse: "Create Course",
		createdAt: "Created at",
		createdBy: "By and with",
		delete: "Delete",
		devTeam: "Development Team",
		educationalInsights: "Educational Insights",
		emptyNumberInput: "This field cannot be empty. Please enter a number.",
		emptyTextInput: "This field cannot be empty and it cannot contain only spaces.",
		expand: "Expand",
		folaprops: "inspired by FoLA²",
		foundingFellows: "Founding Fellows of FoLA²",
		guestView: "Guest View",
		home: "Home",
		learningOutcomes: "Learning Outcomes",
		legalnotice: "Legal Notice",
		logout: "Log out",
		me: "Me",
		metaData: "Meta Data",
		members: "Members",
		no: "No",
		noResponse: "No response from server",
		noResponseMsg: "Your changes could not be saved. Please try again later.",
		notFound: "Not found",
		postalAdress: "Postal Address",
		privacyPolicy: "Privacy Policy",
		productVision: "Product Management & Vision",
		reset: "Reset",
		roleManagemet: "Role Management",
		save: "Save",
		specialThanks: "Special Thanks",
		studiumdigitaleWebsite: "studiumdigitale Website",
		subtitle: "Feedback-Oriented Learning Designs and Analytics",
		survey: "Your Feedback on FoLA | digital",
		tags: "Tags",
		termsOfUse: "Terms of Use",
		title: "FoLA | digital",
		weight: "Weight",
		yes: "Yes",

		description:
			"Seeking an advanced digital platform for seamless collaboration and crafting impactful learning design solutions? Discover FoLA | digital, an innovative tool explicitly designed for this objective! It offers a diverse range of real-time collaboration features, enabling your team to produce highly effective learning designs. FoLA | digital empowers you to develop analytics-driven as well as classical, customized learning experiences, precisely aligned with the needs of both educators and learners while ensuring a strong correlation with the desired learning outcomes.",
		demodescription:
			"Discover the innovative FoLA | digital platform! This interactive tool is designed to introduce educators to the vast potential of analytics and feedback. FoLA | digital offers a wide range of features, including the ability to plan entire courses rather than just small segments. Learn how FoLA | digital can enhance your course planning and analytics experience by providing powerful tools for course design and soon, for feedback processes as well.",
		studiumdigitale: [
			"We develop innovative approaches to improving teaching through the use of new media, both within and outside the university. In doing so, we focus not only on the didactic-technological orientation but also on the compatibility of research and sustainable practices.",
			"As the central innovation unit of Goethe University, we focus on the research, continuous development, and evaluation of modern technology-supported teaching and learning concepts.",
			"We offer comprehensive consulting and training in the field of digital teaching and learning. In this, we emphasize the integration of accessible media content and digital infrastructures, which are closely aligned with our didactic concepts.",
		],
		termsOfUseText: [
			"Your personal data is collected and used to enable you to use the service and to fulfill research and teaching purposes.",
			"Usage is voluntary and free of charge.",
			"The collected usage data is stored in anonymized form and cannot be attributed to your person by researchers.",
			"Research results are published anonymously and may be shared with third parties.",
			"Data processing is based on EU GDPR Article 6 and Article 89 as well as the Hessian Data Protection Act.",
		],
	},
}

export default strings

/**
 * Import this from other translation files to enable auto-completion for your translations.
 */
export type CoreL10nStrings = typeof strings
